import React from "react";
import Login from "./login";
import Dashboard from "./dashboard";
import Profile from "./profile";
import ForgotPassword from "./forgot-password";

import AllCheck from "./checks/AllCheck.js";
import CreateCheck from "./checks/CraeteCheck";
import EditCheck from "./checks/EditCheck";

import AllEmployees from "./employee";
import CreateEmployee from "./employee/CreateEmployee";
import EditEmployee from "./employee/EditEmployee";

import AllRequests from "./leave";
import CreateRequest from "./leave/CreateRequest";
import EditRequest from "./leave/EditRequest";

import LeaveRequest from "./leaverequest/LeaveRequest";
import AllLeaves from "./leaverequest/AllLeaves";
import AllMyRequests from "./leave/MyRequest";
import ResetPassword from "./reset-password";

import Announcements from "./Announcements";
import CreateAnnouncement from "./Announcements/CreateAnnouncement";
import EditAnnouncement from "./Announcements/EditAnnouncement";

import Holidays from "./Holidays";
import CreateHoliday from "./Holidays/CreateHoliday";
import EditHoliday from "./Holidays/EditHoliday";

import DeletedEmployees from "./employee/deletedUsers";
import ViewRequest from "./leave/ViewRequest";
import ViewEmployee from "./employee/ViewEmployee";
import UserMachineLogs from "./checks/UserMachineLogs";
import AllOvertimeRequests from './overtime/AllOvertimeRequests';
import ViewOvertimeRequest from './overtime/ViewOvertimeRequest'; 

import CreateOvertimeRequest from './overtime/CreateOvertimeRequest';
import EditOvertimeRequest from './overtime/EditOvertimeRequest';


export const WEB_PAGES = {
  LOGIN: Login,
  DASHBOARD: Dashboard,
  PROFILE: Profile,
  FORGOTPASSWORD: ForgotPassword,
  RESETPASSWORD: ResetPassword,
   VIEWREQUEST: ViewRequest,
  // ALLCHECk: AllCheck,
   ALLCHECK: AllCheck,
  CREATECHECK: CreateCheck,
  EDITCHECK: EditCheck,
  VIEWEMPLOYEE: ViewEmployee,
  ALLEMPLOYEES: AllEmployees,
  CREATEEMPLOYEE: CreateEmployee,
  EDITEMPLOYEE: EditEmployee,

  ALLREQUESTS: AllRequests,
  CREATEREQUEST: CreateRequest,
  EDITREQUEST: EditRequest,

  LeaveRequest: LeaveRequest,
  AllLeaves: AllLeaves,
  AllMyRequests: AllMyRequests,

  Announcements: Announcements,
  CreateAnnouncement: CreateAnnouncement,
  EditAnnouncement: EditAnnouncement,

  Holidays: Holidays,
  CreateHoliday: CreateHoliday,
  EditHoliday: EditHoliday,

  DeletedEmployees: DeletedEmployees,
    UserMachineLogs: UserMachineLogs,
    VIEWOVERTIMEREQUEST: ViewOvertimeRequest, 
    ALLOVERTIMEREQUESTS: AllOvertimeRequests,
    CREATEOVERTIMEREQUEST: CreateOvertimeRequest,
    EDITOVERTIMEREQUEST: EditOvertimeRequest,
};